import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";

function About() {
  return (
    <section
      id="about"
      className="py-5"
      style={{ background: "#1a1a2e" }}
    >
      <div className="container">
        <div className="text-center mb-5 text-white">
          <h2 className="fw-bold">About Me</h2>
          <div
            className="mx-auto"
            style={{
              width: "80px",
              height: "3px",
              background: "linear-gradient(135deg, #ff4e50, #f9d423)",
              borderRadius: "2px",
            }}
          ></div>
        </div>

        <div
          className="p-5 rounded-4 text-white"
          style={{
            background: "#162447",
            boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
          }}
        >
          <h4 className="fw-semibold mb-3 text-warning">
            Hi, I'm Muhammad Abdullah 👋
          </h4>
          <p className="text-light mb-3">
            I create websites, logos and ads that help your business shine 🌟.  
            My mission is to make your brand seen by the right audience 🚀.
          </p>

          <p className="text-light mb-4">
            I specialize in Web Development, WordPress Development, SEO, Logo Design and Paid Ads 📈.  
            <br/>I love testing strategies and delivering projects that truly get results.
          </p>

          <ul className="list-unstyled mb-3 align-items-center ">
            <li className="mb-2">
    💻 Build fast, fully responsive custom websites, designed to improve user experience and boost online conversions.
  </li>
  <li className="mb-2">
    🖥️ Create WordPress websites, Blogs, E-commerce stores that are easy to manage, update and scale.
  </li>
  <li className="mb-2">
    🎨 Design unique logos and complete brand identity kits to make your business visually stand out professionally.
  </li>
  <li className="mb-2">
    📣 Launch targeted advertising campaigns on Google, Facebook, Instagram, and other platforms to reach the right audience.
  </li>
  <li className="mb-2">
    🔍 Optimize websites with SEO, including keyword research, on-page optimization and performance tracking for growth.
  </li>
  <li className="mb-2">
    ✅ Deliver reliable, results-driven solutions that help your brand grow, increase visibility and achieve measurable goals.
  </li>
          </ul>

          {/* GitHub & LinkedIn Paragraph with Icons */}
          <h1 className="text-light mt-4 fs-5">
          If you want to check out my code and projects, visit my{" "}
          <a
            href="https://github.com/Muhammad-Abdullah-Coder"
            target="_blank"
            rel="noopener noreferrer"
            className="text-warning fw-bold d-inline-flex align-items-center"
          >
          <FaGithub className="me-2" /> GitHub
          </a>
          . If you just want to see my professional connections, check out my{" "}
          <a
            href="https://www.linkedin.com/in/muhammad-abdullah-coder/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-warning fw-bold d-inline-flex align-items-center"
          >
          <FaLinkedin className="me-2" /> LinkedIn
          </a>
          .
          </h1>  
      </div>
      </div>
    </section>
  );
}

export default About;
